import request from './base/request';
import NamespaceEnum from '@/constants/NamespaceEnum';
import { getUserIdFromStorage } from '@/global/CommonUtils';

export interface NoticeItem {
  noticeId: number;
  title?: string;
  content?: string;
  noticeTitle?: string;
  noticeContent?: string;
  orderNo?: string;
  status?: string | number;
  createTime?: string;
  [key: string]: unknown;
}

/** 从文本中提取纯数字订单编号 */
function extractOrderNoDigits(value: string): string | undefined {
  const match = value.trim().match(/\d{10,}/);
  return match?.[0];
}

/** 从消息中提取订单编号 */
export function getOrderNoFromNotice(item: NoticeItem): string | undefined {
  const direct = item.orderNo ?? item.businessNo ?? item.linkParam;
  if (direct) {
    return extractOrderNoDigits(String(direct)) ?? String(direct).trim();
  }

  const text = [item.content, item.noticeContent, item.title, item.noticeTitle]
    .filter(Boolean)
    .join(' ');
  if (!text) return undefined;

  const labeledMatch = text.match(/(?:订单确认|订单编号|订单)[：:]\s*([^\s]+)/);
  if (labeledMatch?.[1]) {
    return extractOrderNoDigits(labeledMatch[1]);
  }

  return extractOrderNoDigits(text);
}

export interface NoticePageResult {
  code: number;
  data?: {
    records?: NoticeItem[];
    total?: number;
  };
}

/** 分页查询消息列表 POST /sys/notice/list/page */
export async function fetchNoticePageList(params?: {
  status?: string;
  clientUserId?: string | number;
  noticeType?: string;
  pageNum?: number;
  pageSize?: number;
}): Promise<NoticePageResult> {
  const {
    status,
    clientUserId = getUserIdFromStorage(),
    noticeType = '2',
    pageNum = 1,
    pageSize = 50,
  } = params || {};
  const body: Record<string, unknown> = {
    clientUserId,
    noticeType,
    page: {
      pageNum,
      pageSize,
      orderByColumn: 'create_time',
      isAsc: 'desc',
    },
  };
  if (status !== undefined) {
    body.status = status;
  }
  return request.post(`${NamespaceEnum.Notice}/list/page`, body) as Promise<NoticePageResult>;
}

/** 标记消息已读 PUT /sys/notice/edit */
export async function markNoticeAsRead(noticeId: number) {
  return request.put(`${NamespaceEnum.Notice}/edit`, {
    noticeId,
    status: '1',
  });
}
